import { IMAGES } from 'config/images';
import { Layout } from 'modules/minimal-ui-theme';
import { ZENJOB_PURPLE_LOGO_ALT_TEXT } from '../constants';

const childrenStyles = {
  height: '100%',
  img: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '3rem',
    maxHeight: '70vh'
  }
};

export const LoadingScreen = () => (
  <Layout childrenStyles={childrenStyles}>
    <img alt={ZENJOB_PURPLE_LOGO_ALT_TEXT} src={IMAGES.proLogoPurple} />
  </Layout>
);
